<template>
  <div class="work-wrap">
    <div class="work-top-box">
      <div @click="backHandle">返回</div>
      <div></div>
    </div>

    <div class="work-center-box">
      <div class="mt-10" style="overflow-y:auto;height: calc(100% - 70px);" ref="dataViewRef" v-if="dataList.length">
        <div class="work-card-box mb-10" v-for="(item,i) in dataList" :key="i">
          <div class="work-title">
            <div class="title cell">{{item.space}}</div>
            <div class="work-status">{{item.applyStatusName}}</div>
          </div>
          <div class="work-content-box mt-10">
            <div class="">设备名称：
              <span v-if="item.deviceList.length">
                <span v-for="(obj,i) in item.deviceList" :key="i">
                  <span style="word-break: break-all;white-space: pre-wrap;">{{obj.deviceName}}（{{obj.deviceNo}}）</span>
                  <span v-if="i < item.deviceList.length - 1">，</span>
                </span>
              </span>
              <span v-else>—</span>
            </div>
            <div class="mt-5" style="word-break: break-all;">故障备注：{{item.faultDescription}}</div>
            <div class="mt-5">上报时间：{{item.reportTime}}</div>
          </div>
          <div class="work-bottom-box mt-10">
            <div class="work-level"></div>
            <div class="" @click="detailHandle(item)">查看详情<i class="el-icon-arrow-right"></i></div>
          </div>
        </div>
      </div>
      <div v-else class="mt-20" ref="dataViewRef">
        <div style="color:#909399;text-align:center">暂无数据</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dataList: [],
      faultImages: [],

      startClientY: 0,
      endClientY: 0,
      isScrolledToTop: true,
    }
  },
  activated() {
    this.getHistoryData();
  },
  mounted() {
    document.addEventListener('touchstart', this.preventStartScroll, { passive: false });
    document.addEventListener('touchmove', this.preventScroll, { passive: false });
  },
  beforeDestroy() {
    document.addEventListener('touchstart', this.preventStartScroll);
    document.addEventListener('touchmove', this.preventScroll);
  },
  methods: {
    // 下拉刷新
    preventStartScroll(event) {
      this.isScrolledToTop = this.$refs.dataViewRef.scrollTop === 0 ? true : false;
      this.startClientY = event.touches[0].clientY;
    },
    preventScroll(event) {
      if (this.isScrolledToTop && (event.touches[0].clientY - this.startClientY > 0)) {
        event.preventDefault();
        if (event.touches[0].clientY - this.startClientY > 160) {
          this.getHistoryData();
        }
      }
    },
    getHistoryData() {
      let params = {
        isReporter: true
      }
      this.$http.get(this.$API.repair_apply_queryList, { params }).then(res => {
        this.dataList = res.data || [];
      })
    },
    backHandle() {
      let url = '/fault/report';
      window.location.assign(url);
      // this.$router.push({ path: '/fault/report' });
    },
    detailHandle(data) {
      let url = '/fault/report/history/detail?id=' + data.id;
      window.location.assign(url);
      // this.$router.push({ path: '/fault/report/history/detail', query: { id: data.id } });
    }
  }
}
</script>

<style lang="scss" scoped>
.work-wrap {
  height: 100%;
}
.work-top-box {
  display: flex;
  height: 50px;
  background-color: #fff;
  justify-content: space-between;
  align-items: center;
  font-size: 1.6rem;
  padding: 0 10px;
}
.work-center-box {
  padding: 0 10px;
  height: 100%;
}
.work-bottom-box {
  display: flex;
  font-size: 1.6rem;
  justify-content: space-between;
}
.work-card-box {
  background-color: #fff;
  border-radius: 8px;
  padding: 10px;
  .work-title {
    display: flex;
    .work-status {
      flex: 1 0 120px;
      text-align: right;
      font-size: 1.6rem;
    }
    .title {
      font-size: 1.6rem;
    }
  }
  .work-content-box {
    padding: 10px;
    font-size: 1.6rem;
    border-radius: 6px;
    background-color: #f9fafd;
  }
}
.detail-deal-btn {
  height: 40px;
  line-height: 40px;
  border-radius: 40px;
  color: #fff;
  background-color: #2f70ff;
  text-align: center;
}
</style>
